
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Calque_1","data-name":"Calque 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"285 0 630 990"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('title',[_v('p')]),_c('g',[_c('rect',{staticClass:"cls-1",attrs:{"x":"-10","width":"1204","height":"1200","rx":"68.97","ry":"68.97"}}),_c('path',{staticClass:"cls-2",attrs:{"d":"M835.08,698.67C793,673.09,748.83,651.05,705.2,628.84c-14.23-6-24-21.18-24.85-38.59-2.77-27.44,6.15-48.77,20.85-70,44.87-63,69.34-142,69.25-223.49C770.45,170.89,696.2,81,585.79,85.66,504.84,89.28,436.9,152,423.44,244.26c-15.93,106.22,10.69,200.21,68.25,283.24,31.08,45,22.69,83.81-23.47,106.91a893.58,893.58,0,0,0-110.34,62,335.31,335.31,0,0,0-72.09,69A105.52,105.52,0,0,0,268.14,800H914a181.57,181.57,0,0,0-18.86-46.54C879.48,727.53,860.7,714.6,835.08,698.67Z"}})])])
          )
        }
      }
    